var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ml-layout',[_c('div',{staticClass:"ml-main"},[_vm._v(" 实验中心 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }